import { useEffect, useMemo, useRef, useState } from 'react'
import { useOverlayActions, useOverlays } from '../../contexts/StoreContext'
import { useCatalog } from '../../contexts/CatalogContext'
import { quizQuestions } from '../../data/quiz'
import { useSite } from '../../contexts/SiteContext'
import { tierIn } from '../../data/gifts'
import { DRAWER_EXIT_MS, pickRoutine, starterProduct } from './quizRules'

/** Antwoorden, uitslag en het open/dicht-gedrag van de huidquiz. */
export function useSkinQuiz() {
  const { quizOpen } = useOverlays()
  const { closeQuiz } = useOverlayActions()
  const { routines, routineById, routineTotals, concernById, concerns, treatmentForConcern } = useCatalog()
  const { giftTiers } = useSite()
  const [answers, setAnswers] = useState<string[]>([])
  /** Verhoogd bij "Opnieuw doen", zodat het e-mailformulier ook leeg begint. */
  const [round, setRound] = useState(0)

  const step = answers.length
  const question = quizQuestions[step]
  const done = question === undefined

  const result = useMemo(
    () => (done ? pickRoutine(quizQuestions, answers, { routines, routineById, concernById }) : undefined),
    [answers, done, routines, routineById, concernById],
  )
  const totals = result ? routineTotals(result) : undefined
  const gift = totals ? tierIn(giftTiers, totals.price) : undefined
  const starter = totals ? starterProduct(totals.items) : undefined
  // De salonkant van het advies: de behandeling bij de klacht waar dit protocol bij hoort.
  const concern = result ? concerns.find((c) => c.routineId === result.id) : undefined
  const treatment = concern ? treatmentForConcern(concern) : undefined

  const reset = () => {
    setAnswers([])
    setRound((r) => r + 1)
  }

  // Na het sluiten leeg maken zodra de lade weg is. Gaat hij binnen die tijd weer open,
  // dan blijft alles staan (geen "flits" van een lege quiz).
  const resetTimer = useRef<number>()
  const close = () => {
    closeQuiz()
    window.clearTimeout(resetTimer.current)
    resetTimer.current = window.setTimeout(reset, DRAWER_EXIT_MS)
  }
  useEffect(() => {
    if (quizOpen) window.clearTimeout(resetTimer.current)
  }, [quizOpen])
  useEffect(() => () => window.clearTimeout(resetTimer.current), [])

  return {
    open: quizOpen,
    close,
    /** Sluiten zonder leeg te maken (bijv. doorklikken naar alle protocollen). */
    closeKeep: closeQuiz,
    reset,
    round,
    answers,
    step,
    total: quizQuestions.length,
    question,
    answer: (label: string) => setAnswers((prev) => [...prev, label]),
    back: () => setAnswers((prev) => prev.slice(0, -1)),
    result,
    totals,
    gift,
    starter,
    treatment,
  }
}
